import React from 'react';
import { DetailsType } from 'src/shared/types/src/lib/invoice.types'
import { getFormattedAmount, dateFormatter } from 'src/shared/utils/src';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { CustomButton } from 'src/app/components';
import CustomAmountComponent from 'src/app/components/CustomAmountComponent';

type DepositPaymentDetailsModalType = {
    paymentData?: DetailsType,
    currency?: string,
    isDepositPaymentDetailsModal: boolean,
    toggleDepositPaymentDetailsModal: () => void,
}

const DepositPaymentDetailsModal: React.FC<DepositPaymentDetailsModalType> = ({ currency, paymentData, isDepositPaymentDetailsModal, toggleDepositPaymentDetailsModal }) => {

    return (
        <Modal 
            isOpen={isDepositPaymentDetailsModal}
            toggle={toggleDepositPaymentDetailsModal}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
            backdrop={"static"}
            keyboard={false}
            centered={true}
        >
            <ModalHeader toggle={toggleDepositPaymentDetailsModal}>Details</ModalHeader>
            <ModalBody>
                <>
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>Transaction ID:</div>
                        <div className='fs-14 text-black pd-l-10'>{paymentData?.txid || '-'}</div>
                    </div>
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>Amount:</div>
                        <div className='fs-14 text-black pd-l-10'>
                            {paymentData?.amount && currency ? <CustomAmountComponent amount={paymentData.amount} currency={currency} /> : '-'}
                        </div>
                    </div>
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>Date:</div>
                        <div className='fs-14 text-black pd-l-10'>{paymentData?.date ? dateFormatter(paymentData?.date) : '-'}</div>
                    </div>
                    <div className='d-flex align-items-center mg-b-15'>
                        <div className='fs-12 text-gray-300'>Payment mode:</div>
                        <div className='fs-14 text-black pd-l-10'>{paymentData?.paymentMode || '-'}</div>
                    </div>
                    <div className='d-flex mg-b-15'>
                        <div className='fs-12 text-gray-300'>Reference:</div>
                        <div className='fs-14 text-black pd-l-10 word-break'>{paymentData?.paymentReference || '-'}</div>
                    </div>
                </>
            </ModalBody>
            <ModalFooter>
                <CustomButton text="Ok" color="primary" onClick={toggleDepositPaymentDetailsModal} />
            </ModalFooter>
            </Modal>
    )
};

export default DepositPaymentDetailsModal;